var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31279)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_31279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_31279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.25 39.5834C82.0833 39.1667 84.1667 35 85 27.0834H77.5C78.3333 35 80.4167 39.1667 81.25 39.5834ZM75.8333 2.91671C70 4.58337 65.8333 9.16671 63.75 14.5834H73.3333C73.75 10 74.5833 6.25004 75.8333 2.91671ZM81.25 2.08337C80.4167 2.50004 78.3333 6.66671 77.5 14.5834H85C84.1667 6.66671 82.0833 2.50004 81.25 2.08337ZM98.75 14.5834C96.6667 9.16671 92.0833 4.58337 86.6667 2.91671C87.9167 5.83337 88.75 10 89.1667 14.5834H98.75ZM63.75 27.0834C65.8333 32.5 70.4167 37.0834 75.8333 38.75C74.5833 35.8334 73.75 31.6667 73.3333 27.0834H63.75ZM85.4167 22.9167V18.75H77.0833V22.9167H85.4167ZM77.0833 97.9167C79.846 97.9167 82.4955 96.8192 84.449 94.8657C86.4025 92.9122 87.5 90.2627 87.5 87.5C87.5 84.7374 86.4025 82.0879 84.449 80.1344C82.4955 78.1808 79.846 77.0834 77.0833 77.0834C74.3207 77.0834 71.6711 78.1808 69.7176 80.1344C67.7641 82.0879 66.6667 84.7374 66.6667 87.5C66.6667 90.2627 67.7641 92.9122 69.7176 94.8657C71.6711 96.8192 74.3207 97.9167 77.0833 97.9167ZM86.6667 38.75C92.5 37.0834 96.6667 32.5 98.75 27.0834H89.1667C88.75 31.6667 87.9167 35.4167 86.6667 38.75ZM99.5833 18.75H89.1667V22.9167H99.5833C100 22.0834 100 21.6667 100 20.8334C100 20 100 19.5834 99.5833 18.75ZM72.9167 22.9167V18.75H62.5V20.8334C62.5 21.6667 62.5 22.0834 62.9167 22.9167H72.9167Z",
    fill: "url(#paint0_linear_4_31279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4167 41.6667C87.5 42.9167 84.1667 43.75 81.25 43.75C68.75 43.75 58.3333 33.3333 58.3333 20.8333C58.3333 19.5833 57.5 18.75 56.25 18.75H18.75L16.6667 7.91667C16.6667 7.08333 15.4167 6.25 14.5833 6.25H2.08333C0.833333 6.25 0 7.08333 0 8.33333C0 9.58333 0.833333 10.4167 2.08333 10.4167H12.9167L22.9167 61.25C24.1667 67.9167 30.4167 72.9167 37.0833 72.9167H85C86.25 72.9167 87.0833 72.0833 87.0833 70.8333C87.0833 69.5833 86.25 68.75 85 68.75H37.5C34.1667 68.75 30.8333 67.0833 29.1667 64.1667L90 55.8333C90.8333 55.8333 91.6667 55 91.6667 54.1667L93.3333 43.75C93.3333 42.9167 93.3333 42.0833 92.5 41.6667H90.4167ZM35.4167 97.9167C38.1793 97.9167 40.8289 96.8192 42.7824 94.8657C44.7359 92.9122 45.8333 90.2627 45.8333 87.5C45.8333 84.7373 44.7359 82.0878 42.7824 80.1343C40.8289 78.1808 38.1793 77.0833 35.4167 77.0833C32.654 77.0833 30.0045 78.1808 28.051 80.1343C26.0975 82.0878 25 84.7373 25 87.5C25 90.2627 26.0975 92.9122 28.051 94.8657C30.0045 96.8192 32.654 97.9167 35.4167 97.9167Z",
    fill: "url(#paint1_linear_4_31279)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_31279",
    x1: 62.0605,
    y1: 9.57035,
    x2: 120.555,
    y2: 33.6736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_31279",
    x1: -1.09375,
    y1: 13.4115,
    x2: 78.1328,
    y2: 98.3577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/E-Commerce.3aa17e3e6fec30874283d370b46bab61.svg";
export { ForwardRef as ReactComponent };